import {
	serverAddr,
	fileServerAddr,
	serverAddrForXLSX,
	serverAddrForCSV,
} from "../networkConfig";
// fileServerAddr
export default {
	uploadQuestionAttachment(params) {
		return fileServerAddr.post(`tasks/question_attachment/upload/`, params, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	},
	listAllLicenses(page, page_size, params) {
		return serverAddr.post(
			`license/management/list/?page=${page}&page_size=${page_size}`,
			params
		);
	},
	listAllFiltersDataLicenses(params) {
		return serverAddr.post(`license/management/filters/data/`, params);
	},
	addUpdateDeleteLicenses(params) {
		return serverAddr.post(`license/management/add/update/`, params);
	},
	deleteLicenseAttachments(params) {
		return serverAddr.post(`license/management/attachment/delete/`, params);
	},
	fetchLicensesDataByID(id) {
		return serverAddr.get(`license/management/${id}/`);
	},
	downloadCSVLicenses(params) {
		return serverAddrForCSV.post(`license/management/csv/`, params);
	},
	listLicensesNames(value) {
		return serverAddr.get(`license/management/license_names/list/?include_archived=${value}`);
	},
	listAllLicensesNames() {
		return serverAddr.get(`license/management/license_names/list/`);
	},
	archiveLicenseSetting(params) {
		return serverAddr.post(`license/management/archive_name/`, params);
	},
	fetchLicenseSettingByID(id) {
		return serverAddr.get(
			`license/management/get/license_settings/?license_name_id=${id}`
		);
	},
	fetchAllDesignations() {
		return serverAddr.post(`/users/designations/list/?get_all=true`);
	},
	fetchAllUsersByDesignations(params) {
		return serverAddr.post(`users/all_users_v1/`, params);
	},
	addUpdateLicenseSettings(params) {
		return serverAddr.post(`license/management/settings/add/update/`, params);
	},
};
